import React from 'react';
import classNames from 'classnames';
import Input from '../Input';
import './SuiteAreas.scss';
import Checkbox from '../Checkbox';
import './Checkbox.scss';
import Icon from '../Icon';
import Col from '../Col';
import Row from '../Row';

const SuiteAreas = ({ checked, disabled, label, id, value, textValue, onInputChange, onAddArea, isSpark, ...props }) => (
  <label
    className='checkbox'
    style={{cursor: isSpark && 'not-allowed'}}
    >  
    <Row>
      <Col md="5"  style={{paddingLeft:'1.2rem'}}>

        {label ? label : 'Other'}
        <input
          className="checkbox__control"
          type="checkbox"
          id={id}
          value={value}
          disabled={isSpark}
          {...props}
        />
        <span class={
          classNames(
            "checkmark",
            {
              'checkmark--checked': value
            }
          )

        }>
          <Icon
            glyph="check"
            weight="regular"
          />
        </span></Col>
      <Row>
        <Col md={7} style={{paddingLeft:'1.3rem'}}>

          <input
            className="title__control"
            type='text'
            value={textValue}
            placeholder='Custom Label'
            onChange={onInputChange}
            disabled={disabled}
          />
        </Col>
      </Row>
      {label === 'Other' ?
        <div onClick={ () => textValue !== '' ? onAddArea() : alert('Please Enter custom label name for adding other check box')}>
          <Icon
            glyph="plus-circle"
            weight="light"
            size="small"
          /> </div>
        : null}
    </Row>
  </label>
);

export default SuiteAreas;
